export default function NoResults({ text = "No results found" }: { text?: string }) {
    return (
        <div className="tw-flex tw-cursor-not-allowed tw-flex-row tw-items-center tw-gap-2 tw-pt-2 tw-text-sm tw-opacity-50">
            <p className="tw-line-clamp-1 tw-flex-grow">{text}</p>
        </div>
    )
}